module.exports = __webpack_public_path__ + "assets/img/duihuan.5ac4f8c6.png";